import { SurfaceOperation } from '../../Enums/SurfaceOperation.enum';

export const handleSurfacesOperation = <T, _>(
	current: T[],
	surfaces: T[],
	operation: SurfaceOperation,
): T[] => {
	if (operation === SurfaceOperation.ADD) {
		const added = surfaces.filter(s => !current.includes(s));
		return [...current, ...added];
	} else if (operation === SurfaceOperation.REMOVE) {
		return current.filter(s => !surfaces.includes(s));
	} else if (operation === SurfaceOperation.REPLACE) {
		return surfaces;
	}
	return current;
};
